import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 17"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("g", { "clip-path": "url(#i370297519__a)" }, [
      _createElementVNode("path", {
        fill: "#FFB524",
        d: "m13.365 8.723-7 7.5a.5.5 0 0 1-.855-.438l.916-4.583L2.824 9.85a.5.5 0 0 1-.187-.813l7-7.5a.5.5 0 0 1 .855.438l-.919 4.588 3.602 1.35a.5.5 0 0 1 .188.81h.002Z"
      })
    ], -1),
    _createElementVNode("defs", null, [
      _createElementVNode("clipPath", { id: "i370297519__a" }, [
        _createElementVNode("path", {
          fill: "#fff",
          d: "M0 .881h16v16H0z"
        })
      ])
    ], -1)
  ])))
}
export default { render: render }